const SvgIconHeart = (props) => (
  <svg viewBox="0 0 18 16" {...props}>
    <path
      d="M16.54 8.498L9 16 1.5 8.54A4.944 4.944 0 010 4.987C0 2.232 2.243 0 5.013 0 6.63 0 8.083.763 9 1.959A5.019 5.019 0 0112.987 0C15.757 0 18 2.232 18 4.988a5.007 5.007 0 01-1.46 3.51"
      fill="#F05F40"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgIconHeart;
